export const hourlyExcelData = [
    {
        "id": 1,
        "vrf_no": "#VRFk1no",
        "project_id": 2,
        "nationality_id": 1,
        "project_vendor_id": 3,
        "project_vendor_job_enquiry_id": 1,
        "visa_profession_id": 12,
        "job_position_id": 1,
        "company_id": 1,
        "visa_quantity": "100",
        "remark": "All process completed",
        "visa_number": "321210",
        "visa_date": "10-03-2023",
        "visa_expiry_date": "10-04-2024",
        "sadad_number": "3434341",
        "status": "Issued",
        "gr_status": "Pending",
        "authorized_date": null,
        "visa_process_in_gov_portal": "Not Started",
        "finance_requested": "NO",
        "finance_status": "Pending",
        "available_quantity": 8,
        "gr_requested_visa_quantity": null,
        "file": "https://slg-laravel-dev.takeleap.in/api/v1/images/profile_default.png",
        "stock_update": "NO",
        "created_at": "2023-08-07T09:39:58.000000Z",
        "updated_at": "2023-08-09T08:19:20.000000Z",
        "project": {
            "id": 2,
            "name": "Saleem Test 4",
            "project_id": "PR-575175/2023"
        },
        "nationality": {
            "id": 1,
            "name": "INDIA"
        },
        "visa_profession": {
            "id": 12,
            "name": "asdfee3dd4sdfsdf"
        },
        "job_position": {
            "id": 1,
            "name": "ELECTRICIAN"
        },
        "company": {
            "id": 1,
            "name": "Reed and Dorsey Traders"
        },
        "candidate": [
            {
                "id": 3,
                "name": "Achu",
                "visa_stamped": "YES",
                "visa_deployed": "NO",
                "vrf_visa_id": 1
            },
            {
                "id": 4,
                "name": "Abdul",
                "visa_stamped": "NO",
                "visa_deployed": "YES",
                "vrf_visa_id": 1
            },
            {
                "id": 105,
                "name": "Victor Spencer",
                "visa_stamped": "YES",
                "visa_deployed": "YES",
                "vrf_visa_id": 1
            },
            {
                "id": 106,
                "name": "Solomon Morse",
                "visa_stamped": "NO",
                "visa_deployed": "NO",
                "vrf_visa_id": 1
            },
            {
                "id": 107,
                "name": "Sierra Peck",
                "visa_stamped": "YES",
                "visa_deployed": "YES",
                "vrf_visa_id": 1
            },
            {
                "id": 108,
                "name": "aj",
                "visa_stamped": "NO",
                "visa_deployed": "NO",
                "vrf_visa_id": 1
            },
            {
                "id": 109,
                "name": "Heidi Mcmillan",
                "visa_stamped": "NO",
                "visa_deployed": "NO",
                "vrf_visa_id": 1
            },
            {
                "id": 111,
                "name": "Hasad Cortez",
                "visa_stamped": "NO",
                "visa_deployed": "NO",
                "vrf_visa_id": 1
            },
            {
                "id": 112,
                "name": "Anastasia Holden",
                "visa_stamped": "NO",
                "visa_deployed": "NO",
                "vrf_visa_id": 1
            }
        ]
    },
    {
        "id": 2,
        "vrf_no": "#VRFFze8",
        "project_id": 2,
        "nationality_id": 1,
        "project_vendor_id": 3,
        "project_vendor_job_enquiry_id": 1,
        "visa_profession_id": 12,
        "job_position_id": 2,
        "company_id": 1,
        "visa_quantity": "40",
        "remark": "All process completed",
        "visa_number": "13131",
        "visa_date": "12-10-2023",
        "visa_expiry_date": "13-12-2024",
        "sadad_number": "232232",
        "status": "Issued",
        "gr_status": "Completed",
        "authorized_date": "07-08-2023",
        "visa_process_in_gov_portal": "Completed",
        "finance_requested": "YES",
        "finance_status": "Completed",
        "available_quantity": 8,
        "gr_requested_visa_quantity": "50",
        "file": "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/vrf/authorize/Dashboard%20%283%29VRFAuthorizeFilewGbr.jpg",
        "stock_update": "NO",
        "created_at": "2023-08-07T09:39:58.000000Z",
        "updated_at": "2023-08-07T20:53:59.000000Z",
        "project": {
            "id": 2,
            "name": "Saleem Test 4",
            "project_id": "PR-575175/2023"
        },
        "nationality": {
            "id": 1,
            "name": "INDIA"
        },
        "visa_profession": {
            "id": 12,
            "name": "asdfee3dd4sdfsdf"
        },
        "job_position": {
            "id": 2,
            "name": "LABORER"
        },
        "company": {
            "id": 1,
            "name": "Reed and Dorsey Traders"
        },
        "candidate": []
    },
    {
        "id": 3,
        "vrf_no": "#VRFIyJE",
        "project_id": 2,
        "nationality_id": 1,
        "project_vendor_id": 3,
        "project_vendor_job_enquiry_id": 1,
        "visa_profession_id": 12,
        "job_position_id": 1,
        "company_id": 1,
        "visa_quantity": "100",
        "remark": "All process completed",
        "visa_number": "12345",
        "visa_date": "18-08-2023",
        "visa_expiry_date": "19-08-2023",
        "sadad_number": "124",
        "status": "Issued",
        "gr_status": "Completed",
        "authorized_date": "09-08-2023",
        "visa_process_in_gov_portal": "Completed",
        "finance_requested": "YES",
        "finance_status": "Completed",
        "available_quantity": 8,
        "gr_requested_visa_quantity": "1234",
        "file": "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/vrf/authorize/Virginia%20Bridges%20Quotation%20Cost%20SheetVRFAuthorizeFileGSOO.pdf",
        "stock_update": "NO",
        "created_at": "2023-08-08T07:45:52.000000Z",
        "updated_at": "2023-08-09T07:58:22.000000Z",
        "project": {
            "id": 2,
            "name": "Saleem Test 4",
            "project_id": "PR-575175/2023"
        },
        "nationality": {
            "id": 1,
            "name": "INDIA"
        },
        "visa_profession": {
            "id": 12,
            "name": "asdfee3dd4sdfsdf"
        },
        "job_position": {
            "id": 1,
            "name": "ELECTRICIAN"
        },
        "company": {
            "id": 1,
            "name": "Reed and Dorsey Traders"
        },
        "candidate": []
    },
    {
        "id": 4,
        "vrf_no": "#VRFhf07",
        "project_id": 2,
        "nationality_id": 1,
        "project_vendor_id": 3,
        "project_vendor_job_enquiry_id": 1,
        "visa_profession_id": 12,
        "job_position_id": 2,
        "company_id": 1,
        "visa_quantity": "40",
        "remark": "All process completed",
        "visa_number": "1234",
        "visa_date": "11-08-2023",
        "visa_expiry_date": "17-08-2023",
        "sadad_number": "534",
        "status": "Issued",
        "gr_status": "Completed",
        "authorized_date": "08-08-2023",
        "visa_process_in_gov_portal": "Started",
        "finance_requested": "YES",
        "finance_status": "Completed",
        "available_quantity": 8,
        "gr_requested_visa_quantity": "422",
        "file": "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/vrf/authorize/Virginia%20Bridges%20Quotation%20Cost%20SheetVRFAuthorizeFile7DCj.pdf",
        "stock_update": "NO",
        "created_at": "2023-08-08T07:45:52.000000Z",
        "updated_at": "2023-08-08T13:56:50.000000Z",
        "project": {
            "id": 2,
            "name": "Saleem Test 4",
            "project_id": "PR-575175/2023"
        },
        "nationality": {
            "id": 1,
            "name": "INDIA"
        },
        "visa_profession": {
            "id": 12,
            "name": "asdfee3dd4sdfsdf"
        },
        "job_position": {
            "id": 2,
            "name": "LABORER"
        },
        "company": {
            "id": 1,
            "name": "Reed and Dorsey Traders"
        },
        "candidate": []
    },
    {
        "id": 5,
        "vrf_no": "#VRF6WJq",
        "project_id": 2,
        "nationality_id": 1,
        "project_vendor_id": 3,
        "project_vendor_job_enquiry_id": 1,
        "visa_profession_id": 12,
        "job_position_id": 2,
        "company_id": 1,
        "visa_quantity": "30",
        "remark": "All process completed",
        "visa_number": "123",
        "visa_date": "12-08-2023",
        "visa_expiry_date": "19-08-2023",
        "sadad_number": "1234",
        "status": "Issued",
        "gr_status": "Completed",
        "authorized_date": "10-08-2023",
        "visa_process_in_gov_portal": "Started",
        "finance_requested": "YES",
        "finance_status": "Completed",
        "available_quantity": 8,
        "gr_requested_visa_quantity": "1321",
        "file": "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/vrf/authorize/Virginia%20Bridges%20Quotation%20Cost%20SheetVRFAuthorizeFileHRTA.pdf",
        "stock_update": "NO",
        "created_at": "2023-08-08T07:46:08.000000Z",
        "updated_at": "2023-08-10T06:30:53.000000Z",
        "project": {
            "id": 2,
            "name": "Saleem Test 4",
            "project_id": "PR-575175/2023"
        },
        "nationality": {
            "id": 1,
            "name": "INDIA"
        },
        "visa_profession": {
            "id": 12,
            "name": "asdfee3dd4sdfsdf"
        },
        "job_position": {
            "id": 2,
            "name": "LABORER"
        },
        "company": {
            "id": 1,
            "name": "Reed and Dorsey Traders"
        },
        "candidate": []
    },
    {
        "id": 11,
        "vrf_no": "#VRFSPmA",
        "project_id": 2,
        "nationality_id": 1,
        "project_vendor_id": 3,
        "project_vendor_job_enquiry_id": 1,
        "visa_profession_id": 12,
        "job_position_id": 1,
        "company_id": 1,
        "visa_quantity": "30",
        "remark": "All process completed",
        "visa_number": "232",
        "visa_date": "02-08-2023",
        "visa_expiry_date": "11-08-2023",
        "sadad_number": "1234",
        "status": "Issued",
        "gr_status": "Completed",
        "authorized_date": "09-08-2023",
        "visa_process_in_gov_portal": "Started",
        "finance_requested": "YES",
        "finance_status": "Completed",
        "available_quantity": 8,
        "gr_requested_visa_quantity": "321",
        "file": "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/vrf/authorize/UX%20Design%20SLA%20%2841%29VRFAuthorizeFilehBOo.jpg",
        "stock_update": "NO",
        "created_at": "2023-08-08T14:21:57.000000Z",
        "updated_at": "2023-08-10T11:02:21.000000Z",
        "project": {
            "id": 2,
            "name": "Saleem Test 4",
            "project_id": "PR-575175/2023"
        },
        "nationality": {
            "id": 1,
            "name": "INDIA"
        },
        "visa_profession": {
            "id": 12,
            "name": "asdfee3dd4sdfsdf"
        },
        "job_position": {
            "id": 1,
            "name": "ELECTRICIAN"
        },
        "company": {
            "id": 1,
            "name": "Reed and Dorsey Traders"
        },
        "candidate": []
    },
    {
        "id": 12,
        "vrf_no": "#VRFwIMl",
        "project_id": 2,
        "nationality_id": 1,
        "project_vendor_id": 3,
        "project_vendor_job_enquiry_id": 1,
        "visa_profession_id": 12,
        "job_position_id": 2,
        "company_id": 1,
        "visa_quantity": "40",
        "remark": "All process completed",
        "visa_number": "23232",
        "visa_date": "10-08-2023",
        "visa_expiry_date": "11-08-2023",
        "sadad_number": "2212",
        "status": "Issued",
        "gr_status": "Completed",
        "authorized_date": "09-08-2023",
        "visa_process_in_gov_portal": "Started",
        "finance_requested": "YES",
        "finance_status": "Completed",
        "available_quantity": 8,
        "gr_requested_visa_quantity": "60",
        "file": "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/vrf/authorize/UX%20Design%20SLA%20%2818%29VRFAuthorizeFileWInS.jpg",
        "stock_update": "NO",
        "created_at": "2023-08-08T14:21:57.000000Z",
        "updated_at": "2023-08-09T05:45:34.000000Z",
        "project": {
            "id": 2,
            "name": "Saleem Test 4",
            "project_id": "PR-575175/2023"
        },
        "nationality": {
            "id": 1,
            "name": "INDIA"
        },
        "visa_profession": {
            "id": 12,
            "name": "asdfee3dd4sdfsdf"
        },
        "job_position": {
            "id": 2,
            "name": "LABORER"
        },
        "company": {
            "id": 1,
            "name": "Reed and Dorsey Traders"
        },
        "candidate": []
    },
    {
        "id": 13,
        "vrf_no": "#VRFfDAh",
        "project_id": 2,
        "nationality_id": 1,
        "project_vendor_id": 3,
        "project_vendor_job_enquiry_id": 1,
        "visa_profession_id": 22,
        "job_position_id": 2,
        "company_id": 12,
        "visa_quantity": "2",
        "remark": "All process completed",
        "visa_number": "9878",
        "visa_date": "19-08-2023",
        "visa_expiry_date": "26-08-2023",
        "sadad_number": "98923",
        "status": "Issued",
        "gr_status": "Completed",
        "authorized_date": "10-08-2023",
        "visa_process_in_gov_portal": "Completed",
        "finance_requested": "YES",
        "finance_status": "Completed",
        "available_quantity": 0,
        "gr_requested_visa_quantity": "32",
        "file": "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/vrf/authorize/Virginia%20Bridges%20Quotation%20Cost%20SheetVRFAuthorizeFilevpOH.pdf",
        "stock_update": "YES",
        "created_at": "2023-08-08T14:33:15.000000Z",
        "updated_at": "2023-08-10T11:10:25.000000Z",
        "project": {
            "id": 2,
            "name": "Saleem Test 4",
            "project_id": "PR-575175/2023"
        },
        "nationality": {
            "id": 1,
            "name": "INDIA"
        },
        "visa_profession": {
            "id": 22,
            "name": "Amar"
        },
        "job_position": {
            "id": 2,
            "name": "LABORER"
        },
        "company": {
            "id": 12,
            "name": "EWAN1"
        },
        "candidate": []
    },
    {
        "id": 14,
        "vrf_no": "#VRFAb8x",
        "project_id": 2,
        "nationality_id": 1,
        "project_vendor_id": 3,
        "project_vendor_job_enquiry_id": 1,
        "visa_profession_id": 23,
        "job_position_id": 2,
        "company_id": 12,
        "visa_quantity": "2",
        "remark": "All process completed",
        "visa_number": "00900",
        "visa_date": "11-08-2023",
        "visa_expiry_date": "01-09-2023",
        "sadad_number": "9877565409876",
        "status": "Issued",
        "gr_status": "Completed",
        "authorized_date": "10-08-2023",
        "visa_process_in_gov_portal": "Started",
        "finance_requested": "YES",
        "finance_status": "Completed",
        "available_quantity": 987616,
        "gr_requested_visa_quantity": "6756547",
        "file": "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/vrf/authorize/Virginia%20Bridges%20Quotation%20Cost%20SheetVRFAuthorizeFileN2SB.pdf",
        "stock_update": "NO",
        "created_at": "2023-08-08T14:33:15.000000Z",
        "updated_at": "2023-08-10T11:08:54.000000Z",
        "project": {
            "id": 2,
            "name": "Saleem Test 4",
            "project_id": "PR-575175/2023"
        },
        "nationality": {
            "id": 1,
            "name": "INDIA"
        },
        "visa_profession": {
            "id": 23,
            "name": "Sam har"
        },
        "job_position": {
            "id": 2,
            "name": "LABORER"
        },
        "company": {
            "id": 12,
            "name": "EWAN1"
        },
        "candidate": []
    },
    {
        "id": 16,
        "vrf_no": "#VRFWJni",
        "project_id": 2,
        "nationality_id": 1,
        "project_vendor_id": 3,
        "project_vendor_job_enquiry_id": 1,
        "visa_profession_id": 20,
        "job_position_id": 8,
        "company_id": 12,
        "visa_quantity": "14",
        "remark": "All process completed",
        "visa_number": "1234",
        "visa_date": "18-08-2023",
        "visa_expiry_date": "26-08-2023",
        "sadad_number": "78",
        "status": "Issued",
        "gr_status": "Completed",
        "authorized_date": "10-08-2023",
        "visa_process_in_gov_portal": "Started",
        "finance_requested": "YES",
        "finance_status": "Completed",
        "available_quantity": 2,
        "gr_requested_visa_quantity": "097",
        "file": "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/vrf/authorize/Virginia%20Bridges%20Quotation%20Cost%20SheetVRFAuthorizeFile1jAh.pdf",
        "stock_update": "NO",
        "created_at": "2023-08-08T14:38:01.000000Z",
        "updated_at": "2023-08-10T11:09:12.000000Z",
        "project": {
            "id": 2,
            "name": "Saleem Test 4",
            "project_id": "PR-575175/2023"
        },
        "nationality": {
            "id": 1,
            "name": "INDIA"
        },
        "visa_profession": {
            "id": 20,
            "name": "Amar"
        },
        "job_position": {
            "id": 8,
            "name": "WAITER"
        },
        "company": {
            "id": 12,
            "name": "EWAN1"
        },
        "candidate": []
    }
  ]